import { Helmet } from 'react-helmet'
import {
  FtpConfigurationsTable,
  NewFtpGenerationForm,
} from 'components/ftpConfigurations'
import { useEffect, useState } from 'react'
import { fetchAggregators } from 'utils/api/aggregatorApi'
import { Spinner } from 'components/common'
import { usePageAccess } from 'hooks'

const FtpConfigurations = () => {
  const { isEditor } = usePageAccess()
  const [aggregatorsData, setAggregatorsData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(true)
  const [refetchConfig, setRefetchConfig] = useState<boolean>(false)

  const getAggregators = async () => {
    try {
      const { data } = await fetchAggregators({
        limit: 500,
        page: 1,
        isActive: true,
      })
      setAggregatorsData({ ...data })
    } catch (error) {
      setAggregatorsData({ docs: [] })
    }
    setLoading(false)
  }

  useEffect(() => {
    getAggregators()
  }, [])

  if (loading) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Spinner size="large" />
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>ORMS FTP Configurations</title>
      </Helmet>

      {/* New FTP Generation */}
      {isEditor && (
        <NewFtpGenerationForm
          aggregators={aggregatorsData.docs || []}
          setRefetchConfig={setRefetchConfig}
        />
      )}

      {/* FTP Configurations */}
      <FtpConfigurationsTable
        aggregators={aggregatorsData.docs}
        refetchConfig={refetchConfig}
      />
    </>
  )
}

export default FtpConfigurations
